;(function ($) {
  'use strict';

  $(document).ready(function() {
    mobile_menu();
    search_toggle();
  });

  $(window).on('resize', function() {
    reset_header();
  });

  const $html = $('html');
  const $main_menu = $('.header__main-menu .main-menu');
  const $toggable = $('.header__toggable');
  const $search_toggle = $('.search-toggle');
  let $mobileMenu = $('.menu-main-toggle');
  let $global_submenus = $main_menu.find('> .menu-item > .menu__submenu');

	// mobile menu toggling
	function mobile_menu() {
    // mobile menu toggle
    $mobileMenu.on('click', function(evt) {
    	evt.preventDefault();
    	evt.stopPropagation();

    	if ( !$(this).hasClass('active') ) {
    		$mobileMenu.addClass('active').attr('aria-label', 'Close the main menu navigation');

    		$toggable.show();

    		setTimeout(function() {
    			$toggable.addClass('active');
    			$html.addClass('menu-is-open').attr('draggable', false);
    		}, 250);
    	}
    	else {        
    		$mobileMenu.removeClass('active').attr('aria-label', 'Open the main menu navigation')

    		$html
    		.removeClass('menu-is-open')
    		.attr('draggable', true);

    		$toggable.removeClass('active');
    		$('.main-menu .submenu--revealed').removeClass('submenu--revealed');

    		setTimeout(function() {
    			$toggable.hide();
    			$global_submenus.removeClass('active').hide();
    		}, 250);
      }
    });
  }

  // reset menu on window resize
  function reset_header() {
    if ( $mobileMenu.css('display') == 'none' ) {
      if ( $('.menu-is-open').length ) {
        $mobileMenu.removeClass('active').attr('aria-label', 'Open the main menu navigation')

        $html
          .removeClass('menu-is-open')
          .attr('draggable', true);

        $toggable.removeClass('active');
        $toggable.css('display','');
        $('.submenu--revealed > .menu__submenu-toggle').trigger('click');
        $('.menu__submenu').css('display','');
      }
      else {
        $toggable.css('display','');
      }
    }
  }

  // search toggle
  function search_toggle() {
    $('.search-toggle').on('click', function() {
      const $searchBar = $(this).parent().find('.search-bar');

      if ( !$(this).hasClass('active') ) {
        $(this).addClass('active').attr('aria-label', $(this).attr('aria-label').replace('Open', 'Close'));
        $searchBar.show();

        setTimeout(function() {
          $searchBar.addClass('active')
            .find('input[type="search"]').focus();
        }, 200);
      }
      else {
        $(this).removeClass('active').attr('aria-label', $(this).attr('aria-label').replace('Close', 'Open'));
        $searchBar.removeClass('active');

        setTimeout(function() {
          $searchBar.hide();
        }, 200);
      }
    })
  }

})(jQuery);